<template>
  <el-dialog title="Bind Guest Role" class="bind" center :visible="visible"
    @update:visible="$emit('update:visible', $event)" @close="resetForm">
    <div v-if="role" class="selected">{{ role.username }} - {{ role.roles.server_name }} - {{ role.roles.cp_role_name }}
    </div>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
      <el-form-item prop="email">
        <el-input v-model.trim="form.email" prefix-icon="icon iconfont icon-youjian" placeholder="Please enter email" />
      </el-form-item>
      <el-form-item prop="code">
        <el-input v-model.trim="form.code" class="codeInput" placeholder="Please enter verification code"
          prefix-icon="icon iconfont icon-baohu1"><el-button slot="append" type="primary" :disabled="canClick"
            @click="sendCode">{{ codeText }}</el-button></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model.trim="form.password" type="password" maxlength="16" autocomplete="new-password"
          prefix-icon="icon iconfont icon-mima" placeholder="Please enter password" show-password />
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input v-model.trim="form.checkPass" type="password" maxlength="16" autocomplete="new-password"
          prefix-icon="icon iconfont icon-mima" placeholder="Please enter password again" show-password />
      </el-form-item>
      <el-form-item class="button-contaniner">
        <el-button type="primary" :loading="loading" @click="submitBind">Confirm</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  name: "BindEmail",
  props: { visible: Boolean, role: { type: Object, default: null }, mockMode: { type: Boolean, default: true } },
  data() {
    return {
      form: { email: "", code: "", password: "", checkPass: "" },
      loading: false,
      canClick: false,
      codeText: "Send Code",
      totalTime: 60, rules: {
        email: [{ required: true, message: "Please enter email", trigger: "blur" }],
        code: [{ required: true, message: "Please enter verification code", trigger: "blur" }],
        password: [{ required: true, message: "Please enter password", trigger: "blur" }, { min: 6, max: 20, message: "Password must be 6-20 characters", trigger: "blur" }],
        checkPass: [{ required: true, message: "Please enter password again", trigger: "blur" }, { validator: (rule, value, callback) => value !== this.form.password ? callback(new Error("Passwords do not match")) : callback(), trigger: "blur" }]
      }
    };
  },
  beforeDestroy() { window.clearInterval(this.codeTimer); },
  methods: {
    sendCode() {
      this.$refs.form.validateField("email", (error) => {
        if (error || this.canClick) return;
        if (this.mockMode) { this.startCodeTimer(); this.$message.success("Verification code sent"); return; }
        const params = { email: this.form.email };
        this.$http.get("center/sendEmailCodeGuset", { params }).then((res) => { if (res.data.code === 200) { this.startCodeTimer(); this.$message.success(res.data.msg || "Verification code sent"); } else this.$message.error(res.data.msg || "Failed to send code"); });
      });
    },
    startCodeTimer() {
      this.canClick = true; this.codeText = this.totalTime + "s";
      this.codeTimer = window.setInterval(() => { this.totalTime--; this.codeText = this.totalTime + "s"; if (this.totalTime < 0) { window.clearInterval(this.codeTimer); this.totalTime = 60; this.codeText = "Send Code"; this.canClick = false; } }, 1000);
    },
    submitBind() {
      this.$refs.form.validate((valid) => {
        if (!valid || !this.role) return;
        const params = { email: this.form.email, code: this.form.code, password: this.form.password };
        if (this.mockMode) { this.$message.success("Bind success"); this.$emit("update:visible", false); return; }
        this.loading = true;
        this.$http.get("/center/guestBindEmail", { params }).then((res) => { if (res.data.code === 200) { this.$message.success(res.data.msg || "Bind success"); this.$emit("update:visible", false); } else this.$message.error(res.data.msg || "Bind failed"); }).catch(() => this.$message.error("Network error, please try again")).finally(() => { this.loading = false; });
      });
    },
    resetForm() { if (this.$refs.form) this.$refs.form.resetFields(); window.clearInterval(this.codeTimer); this.canClick = false; this.totalTime = 60; this.codeText = "Send Code"; },
  },
};
</script>
<style scoped lang="scss">
.bind {

  /deep/ .icon,
  .iconfont {
    color: #409eff;
  }

  /deep/ .el-input-group__append {
    background: #409eff;
    color: #fff;
  }

  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}

.selected {
  padding: 10px;
  margin-bottom: 16px;
  background: #f5f7fa;
  color: #606266;
}

.button-contaniner {
  text-align: center;/deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}

/deep/.el-dialog {
  border-radius: 32px !important;
}

@media screen and (max-width: 1024px) {
  /deep/.el-dialog {
    width: 90%;
  }
}
</style>
